import { useEffect, useRef } from "react";
import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import type { VesselNominationOutletContext } from "@features/vessel-nomination/add/constants";
import { FORM_FIELDS } from "@features/vessel-nomination/add/constants";
import type { VesselNominationFormData } from "@features/vessel-nomination/add/schema/vesselNominationFormSchema";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { LANG_BASE } from "../PreArrivalQuestionnaire";

const Displacement = () => {
  const { t } = useTranslation();
  const { formData, updateFormData } = useOutletContext<VesselNominationOutletContext>();
  const { trigger, watch } = formData;

  const light = watch(FORM_FIELDS.LIGHT);
  const loaded = watch(FORM_FIELDS.LOADED);
  const previousValuesRef = useRef({ light, loaded });

  useEffect(() => {
    const previousValues = previousValuesRef.current;

    if (light !== previousValues.light || loaded !== previousValues.loaded) {
      if (light && loaded) void trigger([FORM_FIELDS.LOADED]);
    }

    previousValuesRef.current = { light, loaded };
  }, [light, loaded, trigger]);

  return (
    <FormProvider {...formData}>
      <FormSection
        title={t(`${LANG_BASE}.sections.displacement`)}
        className="grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"
      >
        <FormItem<VesselNominationFormData, typeof FORM_FIELDS.LIGHT>
          testId="nomination-light-input"
          name={FORM_FIELDS.LIGHT}
          type="number"
          label={t(`${LANG_BASE}.fields.light`)}
          onFieldChange={updateFormData}
          maxDigits={12}
          decimals={3}
          adornment="MT"
          thousandSeparator
          canBeginWithZero={false}
        />
        <FormItem<VesselNominationFormData, typeof FORM_FIELDS.LOADED>
          testId="nomination-loaded-input"
          name={FORM_FIELDS.LOADED}
          type="number"
          label={t(`${LANG_BASE}.fields.loaded`)}
          onFieldChange={updateFormData}
          maxDigits={12}
          decimals={3}
          adornment="MT"
          thousandSeparator
          canBeginWithZero={false}
        />
        <FormItem<VesselNominationFormData, typeof FORM_FIELDS.ARRIVAL>
          testId="nomination-arrival-input"
          name={FORM_FIELDS.ARRIVAL}
          type="number"
          label={t(`${LANG_BASE}.fields.arrival`)}
          onFieldChange={updateFormData}
          maxDigits={12}
          decimals={3}
          adornment="MT"
          thousandSeparator
          canBeginWithZero={false}
        />
        <FormItem<VesselNominationFormData, typeof FORM_FIELDS.DEPARTURE>
          testId="nomination-departure-input"
          name={FORM_FIELDS.DEPARTURE}
          type="number"
          label={t(`${LANG_BASE}.fields.departure`)}
          onFieldChange={updateFormData}
          maxDigits={12}
          decimals={3}
          adornment="MT"
          thousandSeparator
          canBeginWithZero={false}
        />
      </FormSection>
    </FormProvider>
  );
};

export default Displacement;
